export default __webpack_public_path__ + "static/media/tt-gobeyond.4526165c.png";